/**
 * MDP-495 / ER-9940 — Org Object Assignment Validity.
 *
 * `is_valid` and `invalidity_reason` are served by the backend on position/role
 * payloads. The frontend never re-derives validity client-side — it only maps the
 * enum to the human reason line shown on the browse surfaces.
 */

export const INVALIDITY_REASON_POSITION_HAS_INVALID_ACTIVE_ROLE = "POSITION_HAS_INVALID_ACTIVE_ROLE";

export const INVALIDITY_REASON_LABELS = {
  POSITION_NO_ROLES: "Position has no Roles attached",
  POSITION_NO_ACTIVE_ROLES: "Position has no active Roles attached",
  [INVALIDITY_REASON_POSITION_HAS_INVALID_ACTIVE_ROLE]: "Position has an invalid active Role attached",
  ROLE_NO_RESPONSIBILITIES: "Role has no Responsibilities attached",
  ROLE_NO_ACTIVE_RESPONSIBILITIES: "Role has no active Responsibilities attached",
};

/** Human label for a known enum value; any other non-empty string is passed through; "" when absent. */
export function getInvalidityReasonLabel(reason) {
  if (!reason || typeof reason !== "string") return "";
  return INVALIDITY_REASON_LABELS[reason] || reason;
}

/** Statuses that are painted red when invalid. ARCHIVED (and anything else) is never painted. */
export const INVALIDITY_PAINTED_STATUSES = ["draft", "active", "retired"];

/** True when the payload says invalid and the status is one we paint (DRAFT/ACTIVE/RETIRED, never ARCHIVED). */
export function isInvalidityPainted({ isValid, status, archived } = {}) {
  if (isValid !== false) return false;
  if (archived === true) return false;
  const normalised = String(status ?? "").toLowerCase();
  if (!normalised) return true;
  return INVALIDITY_PAINTED_STATUSES.includes(normalised);
}
